import { TRecommendation } from '../../types/recommendation';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EAnalyticsActionTypes } from './types';

export const setAnalyticsProducts = actionGenerator<EAnalyticsActionTypes.SetProducts, TRecommendation[]>(
  EAnalyticsActionTypes.SetProducts,
);
